import { Entry } from '../Entry'

export function Entry20221222() {
  return (
    <Entry title="22/12/2022 - v3.3.1">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/13633/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
